import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import axios from 'axios'
import Constant from '../../../Constant'
import ActivitiesController from '../../../common/activitiesController/ActivitiesController'
class CarList extends React.Component {
  state = {
    Products_data: [],
    isloading: false,
    isEditing: false,
  }

  componentDidMount() {
    if (this.props?.match?.params?.companyId) {
      this.dashbord()
    }
  }

  dashbord = async () => {
    this.setState({ isloading: true })
    var that = this
    await axios
      .get(Constant.getAPI() + `/car/list-car/${this.props.match.params.companyId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            Products_data: res.data?.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ isloading: false })
      })
  }

  handleStatusChange = async (id, isActive) => {
    var that = this
    var data = {
      id: id,
      is_active: isActive,
    }
    await axios
      .put(Constant.getAPI() + '/car/update-car-status', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          that.dashbord()
        }
      })
      .catch((err) => {
        that.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onEdit = (selectedId, order) => {
    this.setState({ isEditing: true, selectedId, order })
  }

  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  onChangeOrder = (selectedId) => {
    this.setState({ isEditing: false })

    var data = {
      id: selectedId,
      order: parseInt(this.state.order),
    }

    axios
      .put(Constant.getAPI() + '/car/update-car-order', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((data) => {
        if (data.status === 200 && data.data) {
          let tempList = this.state.Products_data

          tempList.forEach((item) => {
            if (item.id === selectedId) {
              item.order = this.state.order
            }
          })

          this.setState({
            Products_data: tempList,
          })
          this.dashbord()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  deleteCar = (id) => {
    Swal.fire({
      title: 'Are you sure to delete this Car?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        var token = `Bearer ${localStorage.getItem('loged_In_auth')}`

        axios
          .delete(Constant.getAPI() + `/car/delete-car/${id}`, {
            headers: {
              Authorization: token,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          })
          .then(() => {
            Swal.fire({
              toast: true,
              icon: 'success',
              position: 'top-end',
              title: 'Deleted Successfully!',
              showConfirmButton: false,
              timerProgressBar: true,
              timer: 2500,
            })
            this.dashbord()
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
      }
    })
  }

  render() {
    const columns = [
      {
        name: 'img_url_en',
        label: 'Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (company_img_url) => {
            return (
              <div>
                {company_img_url !== null ? (
                  <div>
                    {company_img_url?.indexOf('.mp4') !== -1 ? (
                      <video
                        width="250"
                        controls
                      >
                        <source
                          src={
                            company_img_url !== undefined && company_img_url !== null && company_img_url !== {}
                              ? Constant.getImage() + company_img_url
                              : './assets/images/icon.png'
                          }
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      <img
                        src={
                          company_img_url !== undefined && company_img_url !== null && company_img_url !== {}
                            ? Constant.getImage() + company_img_url
                            : './assets/images/icon.png'
                        }
                        className="img-fluid img-40"
                        alt="tbl"
                      />
                    )}
                  </div>
                ) : (
                  <img
                    src={
                      company_img_url !== undefined && company_img_url !== null && company_img_url !== {}
                        ? Constant.getImage() + company_img_url
                        : './assets/images/icon.png'
                    }
                    className="img-fluid img-40"
                    alt="tbl"
                  />
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'name_en',
        label: 'Car Name: English',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (data) => {
            return <>{data || '--'}</>
          },
        },
      },
      {
        name: 'name_ar',
        label: 'Car Name: Arabic',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (data) => {
            return <>{data || '--'}</>
          },
        },
      },
      {
        name: 'description_en',
        label: `Car Description: English`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (data) => {
            return <>{data ? data.substring(0, 50) + '...' : '--'}</>
          },
        },
      },
      {
        name: 'description_ar',
        label: `Car Description: Arabic`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (data) => {
            return <>{data ? data.substring(0, 50) + '...' : '--'}</>
          },
        },
      },
      // {
      //   name: 'createdAt',
      //   label: 'Creation Date',
      //   options: {
      //     filter: true,
      //     sort: true,
      //     customBodyRender: (date) => {
      //       return (
      //         <div>
      //           <Moment format="DD/MM/YYYY">{date}</Moment>
      //         </div>
      //       )
      //     },
      //   },
      // },
      {
        name: 'order',
        label: 'Order',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (order, tableMeta) => {
            var id = tableMeta.rowData[8]
            return (
              <div className="form-group">
                <div className="form-group">
                  <div className="input-group mb-3">
                    {this.state.isEditing ? (
                      this.state.selectedId === id ? (
                        <input
                          type="text"
                          name="order"
                          className="form-control px-1 form-control-sm"
                          style={{ width: '50px' }}
                          onChange={this.onInputChange}
                          value={this.state.order}
                        />
                      ) : (
                        <div
                          className="form-control"
                          style={{ width: '50px' }}
                        >
                          {order}
                        </div>
                      )
                    ) : (
                      <div
                        className="form-control"
                        style={{ width: '50px' }}
                      >
                        {order}
                      </div>
                    )}{' '}
                    <div className="input-group-append border">
                      {this.state.isEditing ? (
                        this.state.selectedId === id ? (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onChangeOrder.bind(this, id)}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-check"></i>
                          </span>
                        ) : (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onEdit.bind(this, id, order)}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                          </span>
                        )
                      ) : (
                        <span
                          className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                          onClick={this.onEdit.bind(this, id, order)}
                        >
                          <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_active, tableMeta) => {
            return (
              <Toggle
                id={tableMeta.rowData[8]}
                checked={is_active === true ? true : false}
                value={is_active}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[8], !is_active, 'isActive')}
              />
            )
          },
        },
      },
      {
        name: 'id',
        label: 'View Gallary',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={`/gallary-list/car/${id}`}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="View Gallary "
                >
                  <i className="f-22 icofont icofont-eye text-dark"></i>
                </Link>
              </div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Pricing',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={`/car-pricing/${this.props.match.params.companyId}/` + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="View Gallary "
                >
                  <i className="f-22 icofont icofont-eye text-dark"></i>
                </Link>
              </div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={`/car/add/${this.props.match.params.companyId}/` + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                {/* <span
                  onClick={this.deleteCar.bind(this, id)}
                  className="m-r-8 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span> */}
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Car List</h4>
                    </div>
                  </div>
                  <Link
                    to={`/car/add/${this.props.match.params.companyId}`}
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    <i className="icofont icofont-plus m-r-5"></i> Add Car
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to={`/car-company`}>
                          <i className="feather">Car Company</i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Car List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        {this.state?.isloading ? (
                          'loading...'
                        ) : (
                          <MUIDataTable
                            title={`Car List`}
                            className="table-responsive"
                            data={this.state.Products_data}
                            columns={columns}
                            options={options}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CarList
